// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"cae5b027","726":"f3c66bb8"}[chunkId] + ".chunk.js";
};